const initialState = {
  isBoxed: false,
};

export default function reducer(state = initialState, actions) {
  return state;
}
